import { sharedCustomsEntryColumns } from './sharedCustomsEntry';
import { createShipmentWorkOrderRecord } from './utils';

export const customsEntry = createShipmentWorkOrderRecord({
  columns: {
    ...sharedCustomsEntryColumns,
  },
});
